import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "@/components/ui/sonner";

// Handles the return from Google sign-in (#session_id=…) silently, then drops the user back where they were.
export const AuthCallback = () => {
  const { hash, pathname, search } = useLocation();
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(hash.slice(1)).get("session_id");
    exchangeSession(sessionId)
      .catch(() => toast.error("Google sign-in failed. Please try again."))
      .finally(() => navigate(pathname + search, { replace: true }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <div className="min-h-screen bg-[#050505]" data-testid="auth-callback" />;
};
